module.exports = __webpack_public_path__ + "static/helmed_horror-de147a0641cc083fee7022856eada09c.jpeg";